import { render, staticRenderFns } from "./Exhibitions.vue?vue&type=template&id=c0e7e1a0&"
import script from "./Exhibitions.vue?vue&type=script&lang=ts&"
export * from "./Exhibitions.vue?vue&type=script&lang=ts&"
import style0 from "./Exhibitions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDataTable,VExpandXTransition,VIcon,VToolbar})
